import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SpinnerComponent } from '../az-spinner/spinner.component';

@Component({
  selector: 'app-download-loading-dialog',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './download-loading-dialog.component.html',
  styleUrl: './download-loading-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadLoadingDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<DownloadLoadingDialogComponent>);

  close(): void {
    this.dialogRef.close();
  }
}
